<ng-container *ngIf="appendTo; else inlineSelect">
  <ng-select
    [items]="displayedItems"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [multiple]="multiple"
    [dropdownPosition]="dropdownPosition"
    [ngModel]="selected"
    (ngModelChange)="handleChange($event)"
    [class.custom-select]="!customStyle"
    [class.custom-style]="customStyle"
    (clear)="onClear()"
    [clearable]="clearable"
    [searchable]="searchable"
    appendTo="body"
    (blur)="handleTouched()"
    (close)="handleTouched(); onClose()"
    (search)="onSearch($event.term)"
  >
    <ng-content></ng-content>
  </ng-select>
</ng-container>

<ng-template #inlineSelect>
  <ng-select
    [items]="displayedItems"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [multiple]="multiple"
    [dropdownPosition]="dropdownPosition"
    [ngModel]="selected"
    (ngModelChange)="handleChange($event)"
    [class.custom-select]="!customStyle"
    [class.custom-style]="customStyle"
    (clear)="onClear()"
    [clearable]="clearable"
    [searchable]="searchable"
    (blur)="handleTouched()"
    (close)="handleTouched(); onClose()"
    (search)="onSearch($event.term)"
  >
    <ng-content></ng-content>
  </ng-select>
</ng-template>
